/**
 * Create a new listener.
 * Copied from V2: https://github.com/nike-internal/dotcom.nav/blob/master/src/lib/listener.js
 * @returns {{call: call, off: off, on: (function(Function): function(): void)}}
 */
function listener() {
  const callbacks = [];

  /**
   * Remove a listener.
   * @param cb {Function}
   */
  function off(cb) {
    if (callbacks.indexOf(cb) > -1) {
      callbacks.splice(callbacks.indexOf(cb), 1);
    }
  }

  /**
   * Add a listener.
   * @param cb {Function}
   * @returns {function(): void}
   */
  function on(cb) {
    const stop = () => off(cb);
    if (!callbacks.includes(cb)) {
      callbacks.push(cb);
    }
    return stop;
  }

  /**
   * Call the listeners with arguments.
   * @param args {*}
   */
  function call(args) {
    callbacks.forEach(cb => cb(args));
  }

  const getCallbacks = () => callbacks;

  return { on, off, call, getCallbacks };
}

export default listener;
